import { useQuery } from "@tanstack/react-query"
import { getAttendance_Report } from "./Attendance_report_Repo"

export const useAttendanceReport=({param={},enable}:{param:any,enable:boolean})=>{
    return useQuery({
        queryKey:['ATTENDANCE_REPORT',param],
        queryFn:()=>getAttendance_Report(param),
        enabled:enable,
        retry:false,
    })
}
